var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title",attrs:{"data-anchor":_vm.getTitleInfo(_vm.type).value}},[_c('p',[_vm._v(_vm._s(_vm.getTitleInfo(_vm.type).label))]),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }